import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';

export default function Box({icon , primary, secondary, color}) {
    return (
        <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
            <ListItem>
                <ListItemAvatar>
                    <Avatar sx={{bgcolor: color}}>
                        {icon}
                    </Avatar>
                </ListItemAvatar>
                <ListItemText 
                    primary = {primary} 
                    secondary = {secondary}
                    sx={{color: color}}
                />
            </ListItem>
        </List>
    );
}